export default __webpack_public_path__ + "static/media/stand_out.ec89b11b.svg";